var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardPartnerManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partnership"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e87700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m210.72 233.24 31.84-37.73 35.32-16.83 65.53 18.86 58.9-28.95a298 298 0 0 1 16.32 31.33 301.32 301.32 0 0 1 22.08 73.08l-62.55 13.9a434.44 434.44 0 0 1 -82.22 68.53 430.69 430.69 0 0 1 -56.76 30.7q-14.18-76.44-28.46-152.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.2 192.86 82.8-16.17c8-1 15.49 3.28 18.29 10 3.36 8.07-.65 18.32-9.71 22.32l-27.8 9 45.57 20.75a44.09 44.09 0 0 1 20.61 19.3q15.68 29.18 31.34 58.36c.13.88 1.33 10.32-5.84 17.1a19.71 19.71 0 0 1 -19.53 4.3 20 20 0 0 1 -30.3 20.87 20 20 0 0 1 -31.87 17.21 25.48 25.48 0 0 1 -12.63 12.89c-10.51 4.73-20.23.1-21.56-.56l-20.36-29.45-69.29-86.78-53.73-20.73a9.17 9.17 0 0 1 -5.8-7.53 97.5 97.5 0 0 1 41.61-91.82 10.55 10.55 0 0 1 12.22.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.41 197.54-45.49-22.46a28.85 28.85 0 0 0 -26.14.31l-64.38 33.66c-9.16 8-11.19 20.88-5.9 29.62 6.48 10.68 23.29 14.16 35.36 4.65l33-16.28 38 6.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.47 283.09 27.45-17.91a16.47 16.47 0 0 1 21.94 23.88l-33.57 26.13c-9.95 5.95-21.8 3.23-26.52-3.72-5.48-8.06-1.98-22.72 10.7-28.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.57 316.56 35.35-24.19c7.42-4.31 16.65-2.17 20.93 4.18 3.56 5.27 3.2 12.69-1.08 18.15l-34.12 29.77c-8.45 4.7-19 2-23.88-5.59a18 18 0 0 1 2.8-22.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.31 316.66-33.41 26c-4.44 6.4-4.58 14.72-.47 20.7 4.93 7.17 15.11 9.75 23.65 5.43l30.78-28.23c5.24-7.08 4.27-16.75-1.63-22.09-4.94-4.47-12.61-5.28-18.92-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.2 346.13-26.28 21.73a16.11 16.11 0 0 0 20.94 23l26.51-24.06a14.81 14.81 0 0 0 -21.17-20.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m343.85 249.25a145.48 145.48 0 0 1 -74-21.64l-36.32 18.51a23 23 0 0 1 -31.53-9.55 22.45 22.45 0 0 1 -1.18-17.31 22.89 22.89 0 0 1 11.54-13.37l55.37-29.64a.5.5 0 0 1 .68.21.49.49 0 0 1 -.21.67l-55.38 29.65a21.93 21.93 0 0 0 -11.06 12.79 21.38 21.38 0 0 0 14.13 27.43 21.81 21.81 0 0 0 17.18-1.76l36.59-18.65a.5.5 0 0 1 .49 0 144.35 144.35 0 0 0 73.71 21.64.49.49 0 0 1 .49.51.5.5 0 0 1 -.5.51z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.82 316.66-31.34-58.37c-4.41-8.21-17.34-17.53-17.47-17.62a.51.51 0 0 1 .59-.82c.54.39 13.24 9.55 17.76 18l31.34 58.36z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.18 317.32a.51.51 0 0 1 -.41-.2.51.51 0 0 1 .11-.7l34.18-25c6.36-4.88 8.47-13.57 4.91-20.22a15.42 15.42 0 0 0 -9.56-7.4 16.76 16.76 0 0 0 -13.23 1.85l-24 15.63a.5.5 0 1 1 -.55-.84l24-15.63a17.81 17.81 0 0 1 14-2 16.42 16.42 0 0 1 10.18 7.9c3.79 7.07 1.57 16.31-5.19 21.49l-34.19 25a.46.46 0 0 1 -.25.12z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.65 345a.48.48 0 0 1 -.37-.17.49.49 0 0 1 .05-.7l34.11-29.77c4-4.84 5-11.37 2.6-16.2a13.85 13.85 0 0 0 -8.3-6.69 17.71 17.71 0 0 0 -13.58 1.37l-25.57 17a.5.5 0 0 1 -.69-.14.49.49 0 0 1 .1-.7l25.6-17a18.78 18.78 0 0 1 14.41-1.48 14.91 14.91 0 0 1 8.88 7.2c2.62 5.18 1.5 12.15-2.78 17.34l-34.11 29.79a.5.5 0 0 1 -.35.15z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.19 369.69a.51.51 0 0 1 -.37-.17.51.51 0 0 1 0-.71l30.06-27.16a15.34 15.34 0 0 0 -18.34-24.57l-21.92 16.7a.5.5 0 1 1 -.6-.79l21.98-16.72a16.34 16.34 0 0 1 19.57 26.13l-30.05 27.16a.55.55 0 0 1 -.33.13z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.7 386.08a.5.5 0 0 1 -.33-.87l20.63-18.75c5.27-5.68 5.48-14.66.43-20-4.17-4.41-11.15-5.49-17-2.62l-16.91 13a.51.51 0 0 1 -.7-.1.5.5 0 0 1 .09-.7l17.09-13.04c6.29-3.1 13.76-1.94 18.23 2.78 5.4 5.71 5.2 15.3-.46 21.39l-20.77 18.83a.5.5 0 0 1 -.3.08z",
    fill: "#68003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.42 281.55a304.34 304.34 0 0 0 27.91-30.79 308.36 308.36 0 0 0 46-81.4l-66.28-48a450 450 0 0 1 -33.69 60.51 450.26 450.26 0 0 1 -46.36 58.83z",
    fill: "#2351fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.71,
    cy: 253.39,
    fill: "#68003c",
    r: 13.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.76 297.33a304.35 304.35 0 0 1 -22.7-34.8 308.38 308.38 0 0 1 -32.64-87.65l74.79-42.47a484.42 484.42 0 0 0 37.13 100c7 13.93 14.32 26.76 21.66 38.5z",
    fill: "#fdc500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.85,
    cy: 270.27,
    fill: "#68003c",
    r: 13.13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPartnerManagementIcon);
export default __webpack_public_path__ + "static/media/dashboard_partner_management_icon.32c71ffc4d701bad73aa453b9bc6a5d4.svg";
export { ForwardRef as ReactComponent };